/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { useDispatch } from 'react-redux';
import { Button } from '@zoopla-eng/zds-components/button';

import { useSocialSignIn } from '../SignIn/hooks/useSocialSignIn/useSocialSignIn';
import {
    setLoggedIn,
    useUser,
    getUserSelector
} from '@zoopla/redux-reducer-user';
import Preferences from '../../Preferences';
import { isNewUser } from '../../utils';
import { User } from '../../../../graphql.generated';
import { SkipLinkContainer, StyledModal } from './index.styles';
import { trackGoogleOneTapClose } from './index.tracking';
import { getSegmentData } from '../../utils/getSegmentData';
import { useOptimizelyFeatureFlag } from '@zoopla/optimizely';
import { liverampAts } from '../../utils/liverampAts';

export const GoogleTap = () => {
    const user = useSelector(getUserSelector);
    const [useLiveRampAts] = useOptimizelyFeatureFlag(
        'client-cmp-108-liveramp-ats'
    );
    const router = useRouter();
    const isGuestUser = user.loggedIn === false && user.loading === false;
    const reduxDispatch = useDispatch();

    // Stop showing Google One Tap prompt on sign in and register pages
    const disallowList = new Set(['/signin', '/register']);
    const isInAllowList = !disallowList.has(router.pathname);

    const [showEmailPrefs, setShowEmailPrefs] = useState(false);
    const { registered } = useUser();
    const segment = getSegmentData(router.pathname);

    const signIn = () => {
        reduxDispatch(setLoggedIn(true));
    };

    const onSuccess = (user?: User) => {
        if (useLiveRampAts) {
            liverampAts(user?.email ?? '');
        }

        if (isNewUser({ registered }, user?.creationDate)) {
            localStorage.setItem('new_register_user', 'true');
            setShowEmailPrefs(true);
            return;
        }

        signIn();
    };

    const [, onSocialMediaSignIn] = useSocialSignIn({
        type: 'googleOneTap',
        actionAfterAuth: {
            eventLabel: 'google_one_tap',
            action: onSuccess
        }
    });

    const initGoogleOneTap = () => {
        onSocialMediaSignIn();
    };

    const close = () => {
        signIn();
        setShowEmailPrefs(false);
    };

    const formClosed = () => {
        trackGoogleOneTapClose();
        close();
    };

    if (showEmailPrefs) {
        return (
            <StyledModal isShowing={true} close={formClosed}>
                <Preferences
                    close={close}
                    actionAfterAuth={{
                        action: () => null,
                        eventLabel: 'google_one_tap',
                        segment
                    }}
                />
                <SkipLinkContainer pt="$S200">
                    <Button category="tertiary" onClick={formClosed}>
                        Skip and set later in Email preferences
                    </Button>
                </SkipLinkContainer>
            </StyledModal>
        );
    }
    return isGuestUser && isInAllowList ? (
        <>
            <style
                data-testid="google-one-tap-styles"
                dangerouslySetInnerHTML={{
                    __html: `#credential_picker_container { right: inherit !important; top: inherit !important; left: 1.5rem !important; bottom: 1.5rem !important; }`
                }}
            />
            <Script
                src="https://accounts.google.com/gsi/client"
                onLoad={initGoogleOneTap}
                data-testid="google-one-tap-script"
            />
        </>
    ) : null;
};

export default GoogleTap;
